export function logSpecsModelPath(path?: string | null) {
  if (!path) {
    return;
  }

  console.log(path);
}
